export const PROTECTED_EARNINGS_RATE = 407772;

export default function rechner2022(wages, people) {
    let start = 134000;
    let addon = 0;
    let index = -1;

    if (wages < 9999) {
        wages *= 100;
    }

    if (people === 1) {
        start = 184000;
    }
    if (people === 2) {
        start = 211000;
    }
    if (people === 3) {
        start = 239000;
    }
    if (people === 4) {
        start = 267000;
    }
    if (people === 5) {
        start = 295000;
    }

    if (wages > PROTECTED_EARNINGS_RATE) {
        addon = wages - PROTECTED_EARNINGS_RATE;
        wages = PROTECTED_EARNINGS_RATE;
    }

    while (wages >= start) {
        start += 1000;
        index++;
    }

    if (index === -1) {
        return 0;
    }

    let startAmount = 689;
    let indexAmount = 700;

    if (people === 1) {
        startAmount = 461;
        indexAmount = 500;
    }
    if (people === 2) {
        startAmount = 13;
        indexAmount = 400;
    }
    if (people === 3) {
        startAmount = 43;
        indexAmount = 300;
    }
    if (people === 4) {
        startAmount = 50;
        indexAmount = 200;
    }
    if (people === 5) {
        startAmount = 36;
        indexAmount = 100;
    }

    return startAmount + (index * indexAmount) + addon;
}
